import React from "react";
import dot from "../assests/svg/dot.svg";

const Services = ({ service, stitle, img }) => {
  return (
    <section className="services consult-services">
      <h1>{stitle}</h1>

      {service.map((service, i) => {
        return (
          <div
            key={i}
            className={`service-card ${i % 2 !== 0 ? "reverse" : ""}`}
          >
            {/* Image */}
            <div className="service-img">
              <img src={service.src} className="cover" alt="service" />
            </div>

            {/* Content */}
            <div className="service-text">
              {service.content.map((data, j) => {
                return (
                  <div key={j} className="service__content">
                    {img && <img className="list" src={dot} alt="list" />}

                    <div className="service_info">
                      <h3>
                        <strong>{data.subtitle}</strong>
                      </h3>
                      <p>{data.content}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default Services;
